import React, { ReactElement } from 'react'
import { AllCarrierQueryVariables, useAllCarrierQuery, CarrierListingFragment } from '../../../generated/graphql'
import GridBase, { GridOptions } from '../../General/GridBase/GridBase'
import ellipsish from '../../../icons/ellipsis-h.svg'
import propName from '../../../helpers/propName'
import * as yup from 'yup'
import useForm from 'react-hook-form'
import CarrierSearch from './CarrierSearch'
import styles from '../MultiSearch/MultiSearch.module.scss'

interface Props {
    removeCarrier(carrier: any)
    addCarrier(carrier: any)
    data: any[]
}

export default function MultiCarrierSearch(props: Props): ReactElement {
    const readyToQuery = props.data && props.data.length > 0

    const variables: AllCarrierQueryVariables = {
        sortObject: {},
        filterObject: { carrierKey: { in: props.data } }
    }

    const { data, loading, error } = useAllCarrierQuery({ variables, skip: !readyToQuery })

    const validationSchema = yup.object().shape({
        carrier: yup.object().shape({
            carrierKey: yup.number().required()
        })
    })

    const removeCarrier = (carrier: any) => {
        props.removeCarrier(carrier.carrierKey)
    }

    const carrierGridOptions: GridOptions<CarrierListingFragment> = {
        columnDefs: [
            {
                headerName: "Name",
                dataTransform: o => o.name,
                field: "name"
            }
        ],
        isErrored: !!error,
        isLoading: loading,
        rowData: (loading || error || !readyToQuery) ? [] : data.carrierGetAll,
        rowActions: [
            {
                icon: ellipsish, items: [
                    { displayName: "Remove", action: removeCarrier }
                ]
            }
        ]
    }

    const { register, errors } = useForm<any>({ validationSchema })
    const commonProps = { register, errors }
    const onCarrierSelect = (carrier: CarrierListingFragment) => {
        if (carrier) {
            props.addCarrier(carrier.carrierKey)
        }
    }

    const header = (
        <CarrierSearch
            label="Carriers"
            propertyKey={propName<string>(o => o)}
            onSelect={onCarrierSelect}
            clearOnSelect={true}
            {...commonProps} />
    )

    return (
        <div className={styles.multiSearch__container}>
            <div className="row">
                <div className="col-md-12">
                    {header}
                </div>
            </div>
            <div className={`row ${styles.multiSearch__grid}`}>
                <div className="col-md-12">
                    {props.data && props.data.length > 0 && <GridBase gridOptions={carrierGridOptions} />}
                </div>
            </div>
        </div>
    )

}